// app/javascript/material_evaluations/hydrate.js
import { addMaterialRow, addMachineRow } from "./rows.js";
import { calculateTotals } from "./totals.js";

export async function hydrateLineItems(evaluationId, materialOptions, materialMap, materialsContainer, machineOptions, machinesContainer) {
  try {
    const res = await fetch(`/material_evaluations/${evaluationId}/items`);
    const data = await res.json();

    data.materials.forEach((mi, index) => {
      addMaterialRow(index, materialOptions, materialMap, materialsContainer, mi.material_id, mi.qty, mi.unit_price, mi.supplier || '');
    });
    data.machines.forEach((mc, index) => {
      addMachineRow(index, machineOptions, machinesContainer, mc.machine_id, mc.hrs);
    });

    calculateTotals(materialsContainer);
  } catch (err) {
    console.error("Error hydrating evaluation items:", err);
  }
}
